import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "presentation"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { filter: "url(#filter0_i_2664_417)" }, [
      _createElementVNode("rect", {
        x: "1",
        y: "1",
        width: "18",
        height: "18",
        rx: "4",
        fill: "url(#paint0_linear_2664_417)"
      })
    ], -1),
    _createElementVNode("path", {
      d: "M4.85712 10.6725H6.7562V12.5716H8.10089V10.6725H9.99997V9.32779H8.10089V7.42871H6.7562V9.32779H4.85712V10.6725Z",
      fill: "url(#paint1_linear_2664_417)"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.9285 13.8572H13.857V4.85718L11.9285 6.76247V13.8572Z",
      fill: "url(#paint2_linear_2664_417)"
    }, null, -1)
  ]))]))
}
export default { render: render }